/*
This file is located in the main branch
Last time the file was updated (UTC): [11.12.2024 08:50:34]
Permissions to update outside the main branch: [false]
*/

import {
    DynamicListAddButton,
    DynamicListWrapperProps,
    ValidatedDropDownList,
    ValidatedDynamicListFormComponentProps,
    ValidatedInput,
} from '@finbeat/react-toolkit';
import { QuestionaryInfo } from 'models/api/questionary';
import { useQuestionaryItemListState } from 'providers/QuestionaryItemListProvider';
import { useMemo } from 'react';
import { Trans } from 'react-i18next';
import { Table } from 'reactstrap';
import './QuestionaryModal.scss';

const QuestionariesBlocksItemFormWrapper = ({ children, ...props }: DynamicListWrapperProps) => {
    return (
        <Table bordered>
            <thead>
                <tr className="align-middle">
                    <th>
                        <Trans i18nKey={'BackOfficeName'} />
                    </th>
                    <th className="w-10">
                        <Trans i18nKey={'BackOfficeFlgRequired'} />
                    </th>
                    <th className="w-10 text-center">
                        <DynamicListAddButton {...props} />
                    </th>
                </tr>
            </thead>
            <tbody>{children}</tbody>
        </Table>
    );
};

type QuestionariesBlocksItemFormProps = ValidatedDynamicListFormComponentProps & {
    pageIdx: number;
    blockIdx: number;
};

const QuestionariesBlocksItemForm = ({
    idx,
    pageIdx,
    blockIdx,
    fieldId,
    checkDouble,
}: QuestionariesBlocksItemFormProps) => {
    const items = useQuestionaryItemListState();

    const dropDownItem = useMemo(
        () => [...items.map((x) => ({ id: parseInt(x.value), name: x.text }))],
        [items]
    );

    return (
        <>
            <td>
                <ValidatedDropDownList<QuestionaryInfo>
                    name={`pages.${pageIdx}.blocks.${blockIdx}.items.${idx}.itemId`}
                    items={dropDownItem}
                    isFloating={false}
                    rules={{
                        validate: () => checkDouble(fieldId) ?? undefined,
                    }}
                    isClearable={false}
                />
            </td>
            <td>
                <ValidatedInput<QuestionaryInfo>
                    className="content-center"
                    name={`pages.${pageIdx}.blocks.${blockIdx}.items.${idx}.flgRequired`}
                    type="checkbox"
                    isFloating={false}
                />
            </td>
        </>
    );
};

export { QuestionariesBlocksItemForm, QuestionariesBlocksItemFormWrapper };
